import React ,{useState,useEffect} from 'react';
import styled from 'styled-components';
// import FriendTaskListHeader from 'components/containers/task/FriendTaskListHeader.backup';
import FriendTaskListHeader from 'components/containers/task/FriendTaskListHeader';
import TaskListNavBar from 'components/containers/task/TaskListNavBar';
import TaskListFeed from 'components/containers/feed/TaskListFeed';
import AchivementBlock from 'components/containers/task/AchivementBlock'
import TitleHeader from 'components/presenters/header/TitleHeader';
import ModalCheck from 'components/modal/ModalCheck';
import { useSelector } from 'react-redux';
import serverController from 'server/serverController';
import server from 'server/serverController2';
import { useHistory } from "react-router-dom";
import { formatDate } from 'utils/utils.js';
import UserReportModal from 'components/containers/report/UserReportModal';
import CenterModal from 'components/presenters/modal/CenterModal';
import BottomModal from 'components/presenters/modal/BottomModal';
import { format } from 'date-fns';
import ko from "date-fns/locale/ko"
import arrowDown from 'images/icon/arrow_down-13x50.png';
import lockIcon from 'images/icon/lock_icon-93x120.png';

import TodoList from 'components/containers/task/TodoList';
import Calendar from 'components/containers/calendar/Calendar';

// 투두리스트 아이콘 누르면 나오는 페이지
export default function FriendTaskListLayout({match}) {
    const userInfo = useSelector(state=>{ return state.userInfo;}); 
    const friendUserNo = match.params.friend_no;
    const history = useHistory();

    const [currentPostIndex , setCurrentPostIndex] = useState(0);
    const [isTodoListLoading, setIsTodoListLoading] = useState(false);
    const [isTodoListLoadingEnd, setIsTodoListLoadingEnd] = useState(false);
    const [todoList, setTodoList] = useState([]);
    
    const [disableFeedFlex, setDisableFeedFlex] = useState(false);

    const [showModal,setShowModal] = useState(false); 
    const [userdata , setUserdata] = useState({});
    const [userfriend , setUserfriend] = useState(null);

    const [todoListRelation, setTodoListRelation] = useState(null);
    //Bottom Modal State
    const [bottomModalVisible, setBottomModalVisible] = useState(false);
    const [bottomModalDataList, setBottomModalDataList] = useState([]);
    const [initBottomModal, setInitBottomModal] = useState(false);

    const [displayCalendar, setDisplayCalendar] = useState(false);
    const [reloadAchivement, setReloadAchivement] = useState(false);
    const [selectDay, setSelectDay] = useState(null);
    // const [todoListRelation, setTodoListRelation] = useState(null);
    const [deletedTodoListItem, setDeletedTodoListItem] = useState(null); 
    const [displayTodoList, setDisplayTodoList] = useState(false);

    const [currBar, setCurrBar] = useState('feed');
    const initNavBar = [
        {data: 'feed', txt: "피드", currTab: true}, 
        {data: 'validate',txt : '인증'}, 
        {data: 'calendar',txt: "캘린더"}
    ]
    const [navBarList, setNavBarList] = useState(initNavBar);


    //UserReportModal
    const [userReportModalVisible, setUserReportModalVisible] = useState(false);
    const [userReportTargetNo, setUserReportTargetNo] = useState(null);

    //Center Modal State
    const [initCenterModal, setInitCenterModal] = useState(false);
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState({});
    const [onModalComplete, setOnModalComplete] = useState(null);
    const [onModalCancel, setOnModalCancel] = useState(null);

    //Init Center Modal State
    useEffect(()=>{
        if(initCenterModal === true)
        {
            setCenterModalVisible(false);
            setCenterModalDataList({})
            setOnModalComplete(null);
            setOnModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal]);

    useEffect(()=>{
        setDisableFeedFlex(false);
        if(currBar !== 'calendar')
        {
            setDisplayCalendar(false);
            setSelectDay(new Date(formatDate()));
        }
        else
        {
            setSelectDay(null);
        }
      },[currBar])

    useEffect(() => {
        let userID = parseInt(match.params.friend_no);
        if(selectDay === null)
        {
            setDisplayTodoList(false);
        }
        if (selectDay !== null && userInfo['isLogin'] === true) {
            updateTasks();
        }
    }, [selectDay])

    const infoCallBack=(res)=>{
        if(res.success !== 1){ 
            let errData = res['error']['res_data'];
            if(errData['detail_code'] === "USER_DOES_NOT_EXIST")
            {
                setCenterModalVisible(true);
                setCenterModalDataList({description:"유저 데이터가 존재하지 않습니다."});
                setOnModalComplete(()=>()=>{
                    history.replace('/');
                    setInitCenterModal(true);
                })
            }
            else
            {
                setCenterModalVisible(true);
                setCenterModalDataList({description:"유저 데이터가 존재하지 않습니다."});
                setOnModalComplete(()=>()=>{
                    history.replace('/');
                    setInitCenterModal(true);
                })
            }
            return;
        }
        let jsonData = res.data;
        setUserfriend(jsonData);
        setUserdata(jsonData.user);
        if(jsonData['is_friend'] === true)
        {
            setTodoListRelation("friend");
        }
        else
        {
            setTodoListRelation("other");
        }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        let userID = parseInt(match.params.friend_no);
        if(!userID)
        {
            alert("존재하지 않는 유저입니다.");
            history.goBack();
        }
        else if(userInfo['id'] === match.params.friend_no)
        {
            let redirectUrl = `/task/list`;
            history.replace(redirectUrl);
        }
        else
        {
            serverController.getServerData(`friends/users/${match.params.friend_no}`,infoCallBack);
        }
    },[]);

    useEffect(() => {
        if(initBottomModal === true)
        {
            setBottomModalVisible(false);
            setBottomModalDataList([]);
            setInitBottomModal(false);
        }
    }, [initBottomModal])
      
 
    //날짜 출력 폼 형태 
    function getDateType(date){
        function checkZero(checkString){
        return checkString.toString().length === 1 ?  "0" + checkString : checkString;
        }
        let temp = `${checkZero(date.getFullYear())}-${checkZero(date.getMonth() + 1)}-${checkZero(date.getDate())}`
        return temp;
    }
     
    const updateTasks = () =>{
        setIsTodoListLoading(true)
        setIsTodoListLoadingEnd(false);
        let selectedDate = (selectDay) ? selectDay : formatDate();
        selectedDate = new Date(selectedDate);
        serverController.getServerData(`friends/${match.params.friend_no}/tasks/dates/${getDateType(selectedDate)}/todolist?hide_reported_user=true&hide_reported_task=true`,todolistinfoCallBack); 
    }

    const todolistinfoCallBack= (res) => {
        setIsTodoListLoading(false)
        setIsTodoListLoadingEnd(true);
        if(res.success !== 1){
            alert("예기치 못한 오류가 발생하였습니다.");
            return;
        }
        if(res?.data?.todolist)
        {
            setTodoList(res?.data?.todolist);
        }
    }
    
    
    useEffect(() => {
        let userID = parseInt(match.params.friend_no); 
    },[]);

    //인증사진 데이터 보내기 
    /*--click block--*/
    var isclick = false;

    //친구신청 하기
    const friendSubmitcallBack  = (res) =>{
        if(res.success === 0){
            let errData = res.error.res_data;
            if(errData['detail_code'] === "LOGIN_REQ")
            {
                setCenterModalDataList({
                    type: "redirect",
                    path: "/social",
                    description : "로그인이 필요합니다."
                });

                setOnModalCancel(()=>()=>{
                    setInitCenterModal(true);
                });

                setOnModalComplete(()=>()=>{
                    setInitCenterModal(true);
                });

                setCenterModalVisible(true);
            }
            return;
        }
        
        window.location.reload();
    }

    /*--click block--*/
    const friendSubmit=async ()=> {

        if(isclick)
            return;
        isclick = true;

        let data = {};
        await serverController.insertFilePostFetchController(`friends/users/${match.params.friend_no}/requests`, JSON.stringify(data), friendSubmitcallBack);
        isclick = false;
    }

    // 친구신청 삭제하기
    const friendsdeleteCallBack  = (res) =>{
        if(res.success === 1){
            window.location.reload();
            //serverController.getServerData("auth",test);
        }else {
            alert("실패")
        }
      }

    
    /*--click block--*/
    const frienddeleteSubmit= async ()=> {

        if(isclick)
            return;
        isclick = true;

        let data = {};
        await serverController.updateFileDeleteFetchController(`friends/users/${match.params.friend_no}/requests`,JSON.stringify(data),friendsdeleteCallBack);
        isclick = false;
    }

    //친구신청 수락 하기
    const submitcallBack  = (res) =>{
        if(res.success === 1){
            // alert("성공")
            window.location.reload();
            //serverController.getServerData("auth",test);
        }else {
            alert("실패")
        }
    }

    /*--click block--*/
    const datafrSubmit= async (indexOptional)=> {

        if(isclick)
            return;
        isclick = true;

        var postIndex = indexOptional ? indexOptional : currentPostIndex
        let data = {};
        await serverController.insertFilePostFetchController(`friends/users/${postIndex}/requests/result`, JSON.stringify(data), submitcallBack);
        isclick = false;
    }

    // 친구 삭제하기
    const friendsdelCallBack  = (res) =>{
        console.log(res);
        if(res.success === 1){
            window.location.reload();
            //serverController.getServerData("auth",test);
        }else {
            alert("실패")
        }
    }

    
    /*--click block--*/
    const friendDelSubmit = async ()=> {

        if(isclick)
            return;
        isclick = true;
        let data = {};
        await serverController.updateFileDeleteFetchController(`friends/users/${userdata.no}`,JSON.stringify(data),friendsdelCallBack);
        isclick = false;
    }

    const reportUser = () => {
        const targetUserNo = userdata.no;

        setInitBottomModal(true)
        setUserReportModalVisible(true)
        setUserReportTargetNo(targetUserNo)
    }
    const handleUserReportComplete = () =>
    { 
        const newFriendObj = Object.assign({},userfriend) ;
        newFriendObj['user']['status'] = 'reported';
        setUserfriend(newFriendObj)
        const newUserData = Object.assign({},userdata);
        newUserData['status'] = 'reported';
        setUserdata(newUserData);

        setCenterModalVisible(true);
        setCenterModalDataList({title: '유저 신고 완료', description:"신고접수가 완료되었어요.\n모티너스 운영팀에서 검토 후,\n후속 조치 취하도록 하겠습니다."});
        setOnModalComplete(()=>()=>{
            setInitCenterModal(true);
        })
    }
    const handleDotClick = () => {
        let optionMenu = [];
        if(userInfo['id'] !== match['friend_no'])
        {
            optionMenu.push({type: 'callback', text: '유저 신고', callback: reportUser, style: {color: '#DE0000'}})
        }
        setBottomModalVisible(true);
        setBottomModalDataList(optionMenu);
    }

    const handleEditResult = (e)=>{
        updateTasks();
        setReloadAchivement(true);
      }
      
    const handleDeleteTodoList = (deletedItem) => {
        setDeletedTodoListItem(deletedItem.task.task_date);
    } 

    let currSelectedData = null;
    if(userdata['status'] === 'reported')
    {
        //LockScreenSection, LockIconWrapper, LockIcon, LockTxt
        currSelectedData = [
            <LockScreenSection key={'main-block-screen-component'}  >
                <LockIconWrapper>
                    <LockIcon src={lockIcon}/>
                </LockIconWrapper>
                <LockTxt>신고가 접수된<br />계정이에요.</LockTxt>
            </LockScreenSection>
        ]
    } 
    else if(currBar === 'calendar' && displayCalendar === true)
    {
        if(userfriend?.is_friend !== true)
        {
            currSelectedData = [
                <LockScreenSection key={'main-lock-screen-component'}  >
                    <LockIconWrapper>
                        <LockIcon src={lockIcon}/>
                    </LockIconWrapper>
                    <LockTxt>친구가 되면<br />캘린더를 볼 수 있어요!</LockTxt>
                </LockScreenSection>
            ]
        }
        else
        {
            currSelectedData = [
                <div key={'main-calendar-component'}  style={{position: 'relative',height: '100%', overflowY:'hidden'}}>
                    {userfriend?.is_friend ? (
                        <>
                            <CalendarWrapper>
                                <Calendar 
                                    selectDay={selectDay} 
                                    setSelectDay={setSelectDay} 
                                    deletedTodoListItem={deletedTodoListItem}
                                    setDeletedTodoListItem={setDeletedTodoListItem}
                                    userNo={friendUserNo}
                                />
                            </CalendarWrapper>
                            <TodoListWrapper
                            isOpen={selectDay ? true : false}
                            onTransitionEnd={e => {
                                e.persist();
                                if(selectDay)
                                {
                                setDisplayTodoList(true);
                                }
                            }}
                            >
                                <TodoListHeader>
                                    <TodoListCloseBtnBlock onClick={() => setSelectDay(null)}>
                                    <TodoListCloseBtn>
                                        <TodoListCloseBtnImg src={arrowDown}/>
                                    </TodoListCloseBtn>
                                    </TodoListCloseBtnBlock>
                                    <TodoListHeaderTxt>{`${format(selectDay ? selectDay : new Date(), "MM월 dd일 (EEEEEE)", {locale: ko})}`}</TodoListHeaderTxt>
                                </TodoListHeader>
                                <TodoList 
                                    currentDate={selectDay ? selectDay : new Date()}
                                    setCurrentDate={setSelectDay}
                                    todoList={todoList}
                                    setTodoList={setTodoList}
                                    userNo={userdata['no']}
                                    showAddBtn={false}
                                    disableEditTask={true}
                                    disableCalendar={true}
                                    userRelation={todoListRelation}
                                    onEdit={handleEditResult}
                                    onDeleteResult={handleDeleteTodoList} 
                                    isLoading={isTodoListLoading}
                                    isLoadingEnd={isTodoListLoadingEnd}
                                    emptyTxt={[<React.Fragment key={'empty-calendar-todolist-msg'}>{'인증 기록이 아직 없어요'}</React.Fragment>]}
                                />
                            </TodoListWrapper>
                        </>
                    ) : null}
                    
                </div> 
            ];
        } 
    }
    else if(currBar === 'feed')
    {
        currSelectedData = [<TaskListFeed key={'main-feed-component'} userNo={friendUserNo} 
                emptyTxt={[<React.Fragment key={'empty-feed-msg'}>{'인증 기록이 아직 없어요'}</React.Fragment>]}
                hideReported={true}
                onFeedDetailShow={(showDetail)=>{setDisableFeedFlex(showDetail)}}
                />];
    }
    else if(currBar === 'validate')
    { 
        currSelectedData = [
            <TodoList 
                key={'main-todolist-component'}
                currentDate={selectDay ? selectDay : new Date()}
                setCurrentDate={setSelectDay}
                todoList={todoList}
                setTodoList={setTodoList}
                userNo={userdata['no']} 
                showAddBtn={false}
                disableEditTask={true}
                userRelation={todoListRelation}
                isLoading={isTodoListLoading}
                isLoadingEnd={isTodoListLoadingEnd}
                emptyTxt={[<React.Fragment key={'empty-todolist-msg'}>{'인증 기록이 아직 없어요'}</React.Fragment>]}
            />
        ];
    } 
    
    return (
        <TodolistPageInner>
            <div style={{flex: '0 1 auto', height: 'calc(100vw*(51/375))', minHeight: 'calc(100vw*(51/375))'}}>
                <TitleHeader title={userdata.nickname} background={`#FFFBF0`} isDotBtn={true} handleModalState={handleDotClick}/>
            </div>
            <div style={{
                zIndex: 500, 
                maxHeight: `${(currBar === 'calendar')?'0':'300px'}`,
                transition: `${(currBar === 'calendar')?'all 0.5s cubic-bezier(0, 1, 0, 1)':'all 0.5s'}`,
                overflow : `${(currBar === 'calendar')?'hidden':'visible'}`,
                flex: `0 1 auto`,
                
                flexDirection:'column'}}
                onTransitionEnd={e => {
                  e.persist();
                  if(currBar === 'calendar')
                  {
                    setDisplayCalendar(true);       
                  }
                }}
            >
                <div>
                    {userfriend ? (
                        <FriendTaskListHeader 
                            name={userdata.nickname} 
                            text={userdata.achievement_goal}
                            isfriends={userfriend.is_friend}
                            userfriend={userfriend}
                            userData={userfriend}
                            userdata={userdata}
                            display={"block"}
                            friendsCheck={friendSubmit}
                            friendsunCheck={frienddeleteSubmit}
                            datafrSubmit={datafrSubmit}
                            friendDelSubmit={friendDelSubmit}
                            setCurrentPostIndex={setCurrentPostIndex}
                            setBottomModalVisible={setBottomModalVisible}
                            setBottomModalDataList={setBottomModalDataList}
                            setInitBottomModal={setInitBottomModal}
                        />
                    ) : null}
                </div>
                <div style={{
                    marginBottom : "calc(100vw*(22/375)", 
                    padding: '0 calc(100vw * (17 / 375))'}}> 
                    <AchivementBlock userNo={friendUserNo} />
                </div>
            </div>
            <div style={{ zIndex: 510,flex: `1 1 auto` }}> 
                <TaskListNavBar 
                    itemList={navBarList} 
                    onSelect={(selectedIndex)=>{
                        const newNavBarList = navBarList.slice();
                        for(let i = 0; i < newNavBarList.length; ++i)
                        {
                            if(selectedIndex === i)
                            {
                                newNavBarList[i]['currTab'] = true;
                                setCurrBar(newNavBarList[i]['data'])
                            }
                            else
                            {
                                newNavBarList[i]['currTab'] = false; 
                            }
                        }
                        setNavBarList(newNavBarList)
                    }} 
                />
            </div>

            <div style={{
                zIndex: 510, 
                flex: '1 1 auto', 
                background :'white',
                overflow: 'hidden', 
                height: `${(disableFeedFlex === true)?'auto':'100%'}`
            }}>{currSelectedData}</div>

            <ModalCheck
                showModal={showModal}
                setShowModal={setShowModal}
                subtitle ={"친구가 되면 게시물을 볼 수 있어요!"}
            />
            <UserReportModal 
                zIndex={590}
                userReportModalVisible={userReportModalVisible} 
                setUserReportModalVisible={setUserReportModalVisible}
                userReportTargetNo={userReportTargetNo}
                setUserReportTargetNo={setUserReportTargetNo}
                onUserReportComplete={handleUserReportComplete}
            />
            <BottomModal visible={bottomModalVisible} setVisible={setBottomModalVisible} dataList={bottomModalDataList} />
            <CenterModal zIndex={600} modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
        </TodolistPageInner>
        

    )
}


const TodolistPageInner = styled.div`
    background: #FFFBF0;
    overflow: hidden;
    height: 100%;
    display: -webkit-flex;
    -webkit-flex-flow: column;
`
const CalendarWrapper = styled.div`
  display:flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  // padding-bottom: calc(100vw * (31 / 375));
`;

const TodoListWrapper = styled.div`
  position: absolute;
  top: ${({isOpen}) => isOpen ? "0" : "100%"};
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  height: 100%;
  background: #f7f7f7;
  overflow: hidden;
  transition: all 0.2s linear;
`;

const TodoListHeader = styled.div`
  padding : calc(100vw * (13 / 375)) calc(100vw * (27 / 375)) 0;
  flex: 1 1 auto;
`;

const TodoListCloseBtnBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: calc(100vw * (13.9 / 375));
`;

const TodoListCloseBtn = styled.button`
  width: calc(100vw * (24.6 / 375));
  height: calc(100vw * (6.1 / 375));
`;

const TodoListCloseBtnImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const TodoListHeaderTxt = styled.div`
font-size: calc(100vw * (16 / 375));
line-height: calc(100vw * (23 / 375));
color: #121212;
font-weight:700;
`;

const LockScreenSection = styled.div`
    display:flex;
    align-items: center;
    justify-content:center;
    height: 100%;    
    flex-flow: column;
`
const LockIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content:center;
    width:calc(100vw * (91 / 375));
    height:calc(100vw * (91 / 375));
    border-radius: 100%;
    background: #F7F7F7;
    margin-bottom: calc(100vw * (15 / 375));
`;
const LockIcon = styled.img`
    width:calc(100vw * (31.59 / 375));
    height:calc(100vw * (40.21 / 375));
`;
const LockTxt = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (14 / 375));
    color: #7F7F7F;
    text-align: center;
`